import React from "react";

import Paper from "@mui/material/Paper";
import { Box, Stack, Typography, Chip } from "@mui/material";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  doc,
  setDoc,
  query,
  updateDoc,
  collection as firebaseCollection,
  where,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "../../../firebase";

const Message = ({ chatId, message, entityDonation, t }) => {
  const ref = React.useRef();
  const {
    auth: { profile },
    messageReducer: {  recevierEntityDetail },
  } = useSelector((state) => state);

  React.useEffect(() => {
    if (message.senderId !== profile?.userId && !message.isRead) {
      const update = async () => {
        await setDoc(doc(db, "chats", chatId, "messages", message.id), {
          ...message,
          id: message.id,
          text: message.text,
          senderId: message.senderId,
          date: message.date,
          isRead: true,
        });
      };
      update();
    }
  }, [message]);

  React.useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [message]);

  return (
    <Stack
      direction={message.senderId === profile?.userId ? "row-reverse" : "row"}
      sx={{}}
    >
      <Box sx={{ display: "flex", width: "50%", flexDirection: "column" }}>
        <Stack
          direction={
            message.senderId === profile?.userId ? "row-reverse" : "row"
          }
          alignItems={"center"}
        >
          <Typography
            variant="subtitle2"
            fontWeight={"light"}
            color={"text.secondary"}
            textAlign={message.senderId === profile?.userId ? "end" : "start"}
          >
            {message.date.toDate().toLocaleString("pt-PT", {
              hour: "numeric",
              minute: "numeric",
            })}
          </Typography>
          {message.senderId === profile?.userId && (
            <Chip
              label={message.isRead ? t("read") : t("unRead")}
              icon={
                message.isRead ? (
                  <CheckIcon sx={{ color: "#1B727E", fontSize: "small" }} />
                ) : (
                  <FiberManualRecordIcon
                    sx={{ color: "pink", fontSize: "small" }}
                  />
                )
              }
              sx={{
                backgroundColor: message.isRead ? "#E4F2E8" : "#ffcbcb82",
                // color: message.isRead ? "#1B727E" : "red",
                mx: 1,
                "& .MuiChip-label": {
                  fontWeight: 600,
                  fontFamily: "Poppins",
                },
                "& .MuiChip-icon": {
                  color: message.isRead ? "#1B727E" : "red",
                },
              }}
            />
          )}
        </Stack>
        <Paper
          ref={ref}
          sx={{
            background:
              message.senderId === profile?.userId ? "#f5fae3" : "#d7e4d8",
            p: 2,
            my: 1,

            borderTopRightRadius: message.senderId === profile?.userId ? 0 : 5,
            borderTopLeftRadius: message.senderId !== profile?.userId ? 0 : 5,
          }}
        >
          {/* <Box
          sx={{
            top: "3px",
        left: "50%",
        borderStyle: "solid",
        borderColor: "transparent transparent #000000 transparent",
        borderWidth: "0 10px 10px",
        position:"absolute"
          }}
        /> */}

          <Typography variant="body1" fontFamily={"Poppins"}>
            {message?.text}
          </Typography>
        </Paper>
      </Box>
    </Stack>
  );
};

export default Message;
